import {Component, OnInit, ElementRef, Output, EventEmitter, ViewChild} from '@angular/core';

import {DefaultPackage} from '../services/capd.model';
import { PackageService } from '../services/package.service';

declare var $: any;

@Component({
  selector: 'package-add',
  templateUrl: './package-add.component.html'
})

  /**
   * Component that controls the package-adding modal.
   */
export class PackageAddComponent implements OnInit {
  @Output() listChange: EventEmitter<any> = new EventEmitter();
  // @ViewChild('modalAddPackage', null) modalAddPackage: ElementRef;

  existingPackages: string[];
  newPak: DefaultPackage = { _id: '', name: '', version: '1.0.0', state: 'Unpublished'};
  nameError = false;

  constructor(private _service: PackageService,
              private el: ElementRef){ }

  /**
   * On the app's initialization, get all existing package names to check against later.
   *
   * @func ngOnInit
   */
  ngOnInit() {
    this._service.getNames().then((nameList: string[]) => this.existingPackages = nameList);
  }

  /**
   * Strips alphabetic characters from the version number string.
   *
   * @func stripAlpha
   * @param {boolean} isVersion - true is the current field being edited is "Package version."
   */
  stripAlpha(isVersion: boolean) {
    if (isVersion) {
      this.newPak.version = this.newPak.version.replace(/[a-zA-Z]/g, '');
    }
    else{
      this.newPak.requiredNlpVersion = this.newPak.requiredNlpVersion.replace(/[a-zA-Z]/g, '');
    }
  }

  /**
   * Checks to see if the package already exists, and if not, creates the new package.
   *
   * @func onSubmit
   */
  onSubmit() {
    this.nameError = false;
    if (this.existingPackages.filter(pack => this.newPak.name === pack).length > 0) {
      this.nameError = true;
    }
    else {
      this._service.addPackage(this.newPak).then(() => {
        this.listChange.emit(this.newPak.name);
        $(this.el.nativeElement).find('#modal-add-package').hide();
      });
    }
  }

  /**
   * Clears/resets the new package dialog on exit.
   *
   * @func onCancel
   */
  onCancel() {
    this.newPak = { _id: '', name: '', version: '1.0.0', state: 'Unpublished' };
    this.nameError = false;
  }
}
